<template>
  <div id="copy-link" class="copy-link-container">
    <div v-if="displaySavedToClipboard" class="saved-to-clipboard-container">
      Saved to clipboard!
    </div>
    <v-icon v-else-if="prependIcon" class="left-icon" color="primary">{{ prependIcon }}</v-icon>
    <v-menu
      v-else-if="dropdownOptions.length"
      v-model="showMenu"
      class="menu-container"
      offset-y
      nudge-bottom="24"
      attach="#copy-link"
    >
      <div slot="activator" class="menu-container-activator">
        <div class="icon-container">
          <img :src="selectedOptionIcon" alt="flag" style="width: 1.5rem; height: 1.5rem">
          <img src="/assets/link-icon.svg" alt="link" class="attach-icon-container">
        </div>
        <v-icon color="primary">{{ showMenu ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
      </div>
      <v-list>
        <v-list-tile v-for="(item, index) in dropdownOptions.filter(item => item.url !== url)" :key="index" @click="onChangeMenuOption(item)">
          <img
            :src="item.iconSrc"
            alt="flag"
            style="margin-right: 0.5rem"
          >
          <v-list-tile-title class="options-item" v-text="item.label" />
        </v-list-tile>
      </v-list>
    </v-menu>
    <p class="url-container">{{ url }}</p>
    <button class="copy-button" @click="onCopyClick">
      <v-icon color="primary">content_copy</v-icon>
      copy
    </button>
  </div>
</template>

<script>
export default {
  name: 'copy-link',
  props: {
    prependIcon: String,
    link: String,
    dropdownOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: this.link,
      displaySavedToClipboard: false,
      showMenu: false,
    }
  },
  computed: {
    selectedOptionIcon() {
      const option = this.dropdownOptions.find(item => item.url === this.url)
      if (!option) {
        return ''
      }

      return option.iconSrc
    },
  },
  methods: {
    async onCopyClick() {
      await navigator.clipboard.writeText(this.url)
      this.displaySavedToClipboard = true
      setTimeout(() => {
        this.displaySavedToClipboard = false
      }, 3000)
    },
    onChangeMenuOption(option) {
      this.url = option.url
      this.$emit('update:selected-url', option.url)
    },
  },
}
</script>

<style scoped>
.copy-link-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  background: #E6F1F8;
}

.left-icon {
  padding: 0 0.5rem 0 1rem;
}

.url-container {
  margin: 0;
  color: #0277BD;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  max-width: 100%;
}

.copy-button {
  display: flex;
  height: 3rem;
  padding: 0.75rem 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0 0.5rem 0.5rem 0;

  color: #0277BD;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.01688rem;
  text-transform: uppercase;
}

.copy-button:hover {
  background: #CEE4F2;
}

.saved-to-clipboard-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 1rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  background: #EEF6EF;
  border-radius: 0.5rem;

  color: #55A35D;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.menu-container-activator {
  display: flex;
  padding: 0 0.5rem 0 1rem;
  align-items: center;
  align-self: stretch;
}

::v-deep .v-menu__activator {
  height: 100%;
}

.menu-container {
  min-height: 3rem;
  align-content: center;
  border-radius: 0.5rem 0 0 0.5rem;
}

.menu-container:hover {
  background: #CEE4F2;
}

.icon-container {
  width: 1.75rem;
  height: 1.625rem;
  position: relative;
}

.attach-icon-container {
  width: 0.75rem;
  height: 0.6rem;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #E6F1F8;
  border-radius: 4px;
}

.options-item {
  color: #0277BD;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.015rem;
}

::v-deep .v-menu__content {
  max-width: 100%;
  width: 100%;
}
</style>
